// // Gallery.jsx (This file will contain the Context, Provider, Card, Nav, and Gallery components)
// import React, { createContext, useState, useContext, useEffect } from 'react';

// // --- Data ---
// // In a .jsx file, you define these as regular variables.
// // You might use JSDoc comments for documentation, but they don't enforce types.

// // Define categories as a plain array or object for consistency if needed elsewhere
// // For example:
// // const ALL_CATEGORIES = ['All', 'Fine Dining', 'Cafe', 'Bistro', 'Outdoor'];

// export const restaurants = [
//   { id: 1, category: ['Fine Dining'], image: '/assets/caf_fd_1.jpg' },
//   { id: 2, category: ['Cafe'], image: '/assets/caf_caf_1.jpg' },
//   { id: 3, category: ['Bistro'], image: '/assets/caf_bst_1.jpg' },
//   { id: 4, category: ['Fine Dining'], image: '/assets/caf_fd_2.jpg' },
//   { id: 5, category: ['Bistro'], image: '/assets/caf_bst_2.jpg' },
//   { id: 6, category: ['Cafe'], image: '/assets/caf_caf_2.jpg' },
//   { id: 7, category: ['Fine Dining'], image: '/assets/caf_fd_3.jpg' },
//   { id: 8, category: ['Bistro'], image: '/assets/caf_bst_3.jpg' },
//   { id: 9, category: ['Outdoor'], image: '/assets/caf_otd_2.jpg' },
//   { id: 10, category: ['Cafe'], image: '/assets/caf_caf_3.jpg' },
//   { id: 11, category: ['Outdoor'], image: '/assets/caf_otd_1.jpg' },
//   { id: 12, category: ['Bistro'], image: '/assets/caf_bst_4.jpg' },
//   { id: 13, category: ['Outdoor'], image: '/assets/caf_otd_3.jpg' },
//   { id: 14, category: ['Outdoor'], image: '/assets/caf_otd_4.jpg' },
// ];

// // --- Context ---
// // Context is created without type parameters in JSX
// export const RestaurantContext = createContext(undefined);

// export const useRestaurants = () => {
//   const context = useContext(RestaurantContext);
//   if (context === undefined) { // Check for undefined instead of !context for strictness
//     throw new Error('useRestaurants must be used within a RestaurantProvider');
//   }
//   return context;
// };

// // Props are destructured directly in JSX
// export const RestaurantProvider = ({ children }) => {
//   const [activeCategory, setActiveCategory] = useState('All');

//   // Define categories array directly here as a plain JS array
//   const categories = ['All', 'Fine Dining', 'Cafe', 'Bistro', 'Outdoor'];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveCategory(currentCategory => {
//         const currentIndex = categories.indexOf(currentCategory);
//         const nextIndex = (currentIndex + 1) % categories.length;
//         // No type assertion needed in plain JavaScript
//         return categories[nextIndex];
//       });
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []); // categories is a constant, so no need to add it to dependencies

//   const filteredRestaurants = activeCategory === 'All'
//     ? restaurants
//     : restaurants.filter(restaurant => restaurant.category.includes(activeCategory));

//   return (
//     <RestaurantContext.Provider
//       value={{
//         restaurants,
//         filteredRestaurants,
//         activeCategory,
//         setActiveCategory,
//       }}
//     >
//       {children}
//     </RestaurantContext.Provider>
//   );
// };

// // --- RestaurantCard Component ---
// // Props are destructured directly in JSX
// const RestaurantCard = ({ restaurant }) => {
//   return (
//     <div
//       className="min-w-[300px] md:min-w-[350px] bg-white rounded-lg overflow-hidden shadow-md snap-start transition-transform duration-300 hover:shadow-lg hover:-translate-y-1"
//     >
//       <div className="relative h-60 overflow-hidden">
//         <img
//           src={restaurant.image}
//           alt={`Image of restaurant with ID ${restaurant.id}`}
//           className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
//         />
//         <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
//           <div className="flex gap-2">
//             {restaurant.category.map((cat) => (
//               cat !== 'All' && (
//                 <span
//                   key={cat}
//                   className="text-xs font-medium px-2 py-1 rounded-full bg-white/20 text-white backdrop-blur-sm"
//                 >
//                   {cat}
//                 </span>
//               )
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="p-4">
//         {/* You can add more restaurant details here if available, e.g., name */}
//       </div>
//     </div>
//   );
// };

// // --- Navbar Component ---
// // Define categories array directly here as a plain JS array
// const categories = ['All', 'Fine Dining', 'Cafe', 'Bistro', 'Outdoor'];

// export const Nav = () => { // No React.FC type
//   const { activeCategory, setActiveCategory } = useRestaurants();

//   return (
//     <nav className="flex justify-center mb-8">
//       <div className="inline-flex items-center bg-white rounded-full shadow-sm p-1.5">
//         {categories.map((category) => (
//           <button
//             key={category}
//             onClick={() => setActiveCategory(category)}
//             className={`
//               relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-300 ease-in-out
//               ${activeCategory === category
//                 ? 'text-gray-600 shadow-lg scale-105'
//                 : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
//               }
//             `}
//           >
//             {activeCategory === category && (
//               <span className="absolute inset-0 bg-white/70 rounded-full -z-10 animate-fadeIn"></span>
//             )}
//             {category}
//           </button>
//         ))}
//       </div>
//     </nav>
//   );
// };

// // --- Gallery Component ---
// const Gallery = () => { // No React.FC type
//   const { filteredRestaurants } = useRestaurants();

//   return (
//     <div className="space-y-6">
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {filteredRestaurants.length > 0 ? (
//           <>
//             {/* First row */}
//             <div className="col-span-full grid grid-cols-1 md:grid-cols-3 gap-6">
//               {filteredRestaurants.slice(0, 3).map((restaurant) => (
//                 <RestaurantCard key={restaurant.id} restaurant={restaurant} />
//               ))}
//             </div>

//             {/* Second row */}
//             <div className="col-span-full grid grid-cols-1 md:grid-cols-3 gap-6">
//               {filteredRestaurants.slice(3, 6).map((restaurant) => (
//                 <RestaurantCard key={restaurant.id} restaurant={restaurant} />
//               ))}
//             </div>
//           </>
//         ) : (
//           <div className="col-span-3 flex items-center justify-center h-64">
//             <p className="text-gray-500 text-lg">No restaurants found in this category.</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Gallery;
// Gallery.jsx
import React, { useState, useEffect } from 'react';
// // You can use JSDoc for some basic type hints, but it's not TypeScript's compile-time checking.
// /**
//  * @typedef {Object} Product
//  * @property {number} id
//  * @property {string[]} categories
//  * @property {string} image
//  * @property {string} [name]
//  * @property {string} [description]
// */
// const ProductCategory = {
//   ALL: 'All',
//   LIVING_ROOM: 'Living Room',
//   BEDROOM: 'Bedroom',
//   DINING_ROOM: 'Dining Room',
//   OFFICE: 'Office',
//   FINE_DINING: 'Fine Dining',
//   CAFE: 'Cafe',
//   BISTRO: 'Bistro',
//   OUTDOOR: 'Outdoor',
//   BAR_TOOLS: 'Bar Tools',
//   LOUNGE_SEATING: 'Lounge Seating',
//   RESTAURANT_SEATING: 'Restaurant Seating',
//   BAR_FURNITURE: 'Bar Furniture',
// };
export const livingRoomProducts = [
  {
    id: 1,
    categories: ['Sofas'],
    image: 'https://images.pexels.com/photos/32177962/pexels-photo-32177962/free-photo-of-modern-living-room-interior-with-cozy-sofa.png?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    name: 'Contemporary Linen Sectional Sofa',
    description: 'A cozy and stylish sofa for contemporary living spaces.',
  },
  {
    id: 2,
    categories: ['Armchairs'],
    image: 'https://images.pexels.com/photos/29350087/pexels-photo-29350087/free-photo-of-stylish-wooden-armchair-with-textured-walls.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    name: 'Artisan Oak Accent Armchair',
    description: 'Elegant armchair with a modern design and comfortable seating.',
  },
  {
    id: 3,
    categories: ['Armchairs'],
    image: 'https://images.pexels.com/photos/10120258/pexels-photo-10120258.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    name: 'Plush Comfort Lounge Chair',
    description: 'Perfect for relaxation, a comfortable and aesthetically pleasing lounge chair.',
  },
  {
    id: 4,
    categories: ['Coffee Tables'],
    image: 'https://images.pexels.com/photos/11388164/pexels-photo-11388164.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    name: 'Solid Oak Meridian Coffee Table',
    description: 'Solid oak coffee table with a natural finish, ideal for any living room.',
  },
  {
    id: 5,
    categories: ['Coffee Tables'],
    image: 'https://images.pexels.com/photos/24039484/pexels-photo-24039484/free-photo-of-a-table-in-a-room.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    name: 'Nordic Minimalist Round Table',
    description: 'A sleek, minimalist table perfect for compact spaces or as an accent piece.',
  },
  {
    id: 6,
    categories: ['TV Units'],
    image: 'https://images.pexels.com/photos/6527053/pexels-photo-6527053.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    name: 'Scandinavian Walnut TV Console',
    description: 'Clean lines and practical storage define this modern TV unit.',
  },
];

export const bedroomProducts = [
  { id: 101, categories: ['Bed'], image: 'https://images.pexels.com/photos/28247932/pexels-photo-28247932/free-photo-of-a-hotel-room-with-a-large-bed-and-gold-accents.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2', name: 'Luxury Upholstered Platform Bed', description: 'Comfortable and modern bed frame with premium upholstery.' },
  { id: 102, categories: ['Wardrobe'], image: 'https://images.pexels.com/photos/7535017/pexels-photo-7535017.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2', name: 'Contemporary Sliding Door Wardrobe', description: 'Spacious wardrobe with sleek design and ample storage.' },
  { id: 103, categories: ['Nightstand'], image: 'https://images.pexels.com/photos/32168981/pexels-photo-32168981/free-photo-of-elegant-bedside-table-with-decorative-lamp.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2', name: 'Elegant Marble Top Nightstand', description: 'Compact and stylish nightstand with marble finish.' },
  { id: 104, categories: ['Dresser'], image: 'https://images.pexels.com/photos/5825709/pexels-photo-5825709.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2', name: 'Modern Six-Drawer Dresser', description: 'Functional dresser with ample storage and clean lines.' },
];

export const restaurantProducts = [
  { id: 201, categories: ['Fine Dining', 'Restaurant Seating'], image: '/assets/caf_fd_1.jpg', name: 'Premium Fine Dining Collection', description: 'Luxurious dining area for a refined experience.' },
  { id: 202, categories: ['Cafe', 'Restaurant Seating'], image: '/assets/caf_caf_1.jpg', name: 'Artisan Cafe Seating Set', description: 'Warm and inviting cafe space with handcrafted furniture.' },
  { id: 203, categories: ['Bistro', 'Restaurant Seating'], image: '/assets/caf_bst_1.jpg', name: 'European Bistro Collection', description: 'Intimate setting for a casual meal with authentic charm.' },
  { id: 204, categories: ['Outdoor', 'Restaurant Seating'], image: '/assets/caf_otd_1.jpg', name: 'All-Weather Patio Dining Set', description: 'Durable and stylish outdoor furniture for year-round use.' },
];

export const barProducts = [
  {
    id: 304,
    name: "Adjustable Height Bar Stool",
    categories: ["Bar Stools"],
    image: "https://images.pexels.com/photos/3745525/pexels-photo-3745525.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    id: 305,
    name: "Urban Industrial Bar Counter",
    categories: ["Bar Counters"],
    image: "https://images.pexels.com/photos/32083239/pexels-photo-32083239/free-photo-of-modern-urban-bar-interior-with-empty-seats.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    id: 306,
    name: "Professional Wine Storage Cabinet",
    categories: ["Bar Cabinets"],
    image: "https://images.pexels.com/photos/27819659/pexels-photo-27819659/free-photo-of-a-restaurant-with-shelves-filled-with-wine-bottles.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    id: 307,
    name: "Vintage Industrial Bar Chair",
    categories: ["Bar Chairs"],
    image: "https://images.pexels.com/photos/5491002/pexels-photo-5491002.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    id: 308,
    name: "Rustic Wooden Display Unit",
    categories: ["Storage & Display"],
    image: "https://images.pexels.com/photos/6309831/pexels-photo-6309831.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
  {
    id: 309,
    name: "Contemporary High-Top Bar Table",
    categories: ["Bar Counters"],
    image: "https://images.pexels.com/photos/16657747/pexels-photo-16657747/free-photo-of-modern-interior-design-of-cafe.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  },
];

export const cafeSpaceProducts = [
  { id: 401, categories: ['Fine Dining'], image: '/assets/caf_fd_1.jpg', name: 'Luxe Fine Dining Experience' },
  { id: 402, categories: ['Cafe'], image: '/assets/caf_caf_1.jpg', name: 'Artisan Coffee House Collection' },
  { id: 403, categories: ['Bistro'], image: '/assets/caf_bst_1.jpg', name: 'Classic French Bistro Set' },
  { id: 404, categories: ['Fine Dining'], image: '/assets/caf_fd_2.jpg', name: 'Sophisticated Dining Ensemble' },
  { id: 405, categories: ['Bistro'], image: '/assets/caf_bst_2.jpg', name: 'Urban Bistro Seating' },
  { id: 406, categories: ['Cafe'], image: '/assets/caf_caf_2.jpg', name: 'Modern Cafe Lounge Set' },
  { id: 407, categories: ['Fine Dining'], image: '/assets/caf_fd_3.jpg', name: 'Executive Dining Collection' },
  { id: 408, categories: ['Bistro'], image: '/assets/caf_bst_3.jpg', name: 'Vintage Bistro Furniture' },
  { id: 409, categories: ['Outdoor'], image: '/assets/caf_otd_2.jpg', name: 'Terrace Dining Collection' },
  { id: 410, categories: ['Cafe'], image: '/assets/caf_caf_3.jpg', name: 'Contemporary Cafe Seating' },
  { id: 411, categories: ['Outdoor'], image: '/assets/caf_otd_1.jpg', name: 'Garden Patio Furniture Set' },
  { id: 412, categories: ['Bistro'], image: '/assets/caf_bst_4.jpg', name: 'Industrial Bistro Collection' },
  { id: 413, categories: ['Outdoor'], image: '/assets/caf_otd_3.jpg', name: 'Alfresco Dining Ensemble' },
  { id: 414, categories: ['Outdoor'], image: '/assets/caf_otd_4.jpg', name: 'Outdoor Lounge Collection' },
];

// --- ProductCard Component ---
// In JSX, you define props directly in the functional component signature
// or destructure them from a 'props' object. No interface needed.
const ProductCard = ({ product }) => {
  return (
    <div
      className="w-full bg-white rounded-lg overflow-hidden shadow-md transition-transform duration-300 hover:shadow-lg hover:-translate-y-1"
    >
      <div className="relative overflow-hidden bg-gray-100">
        <div className="aspect-[4/5] w-full">
          <img
            src={product.image}
            alt={product.name || `Image of product with ID ${product.id}`}
            className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
            loading="lazy"
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.src = `https://placehold.co/600x750/E5E7EB/6B7280?text=${encodeURIComponent(product.name || 'Product')}`; 
            }}
          />
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 sm:p-4">
          <div className="flex gap-1.5 sm:gap-2 flex-wrap">
            {product.categories.map((cat) => (
              cat !== 'All' && (
                <span
                  key={cat}
                  className="text-xs font-medium px-2 py-0.5 sm:py-1 rounded-full bg-white/20 text-white backdrop-blur-sm"
                >
                  {cat}
                </span>
              )
            ))}
          </div>
        </div>
      </div>
      <div className="p-3 sm:p-4">
        {product.description && <p className="text-xs sm:text-sm text-gray-900 line-clamp-2">{product.description}</p>}
      </div>
    </div>
  );
};

// --- Gallery Component (Now fully dynamic via props) ---
// Props are directly destructured.
export const Gallery = ({
  products,
  categories,
  autoCycle = true,
  cycleInterval = 5000,
}) => {
  // allCategories is a regular JavaScript array now
  const allCategories = React.useMemo(() => ['All', ...categories], [categories]);
  const [activeCategory, setActiveCategory] = useState('All'); // No type annotation needed for useState
  const [isAutoPlaying, setIsAutoPlaying] = useState(autoCycle);

  // Effect to handle auto-cycling of categories
  useEffect(() => {
    let intervalId; // No type annotation needed for intervalId
    if (isAutoPlaying && autoCycle) {
      intervalId = setInterval(() => {
        setActiveCategory(currentCategory => {
          const currentIndex = allCategories.indexOf(currentCategory);
          const nextIndex = (currentIndex + 1) % allCategories.length;
          // No type assertion needed or allowed in plain JSX
          return allCategories[nextIndex];
        });
      }, cycleInterval);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isAutoPlaying, autoCycle, allCategories, cycleInterval]);

  // Handle manual category selection
  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setIsAutoPlaying(false);
    // Resume auto-play after 8 seconds of inactivity
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  // Filter products based on activeCategory
  const filteredProducts = activeCategory === 'All'
    ? products
    : products.filter(product => product.categories.includes(activeCategory));

  return (
    <div className="space-y-6 sm:space-y-8">
      {/* Navbar for categories */}
      <nav className="flex justify-center mb-6 sm:mb-8 px-2 sm:px-4">
        <div className="inline-flex flex-wrap items-center justify-center bg-white rounded-full shadow-sm p-1 sm:p-1.5 gap-1 sm:gap-0">
          {allCategories.map((category) => (
            <button
              key={category}
              onClick={() => handleCategoryClick(category)}
              className={`
                relative px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium rounded-full transition-all duration-300 ease-in-out whitespace-nowrap
                ${activeCategory === category
                  ? 'text-gray-600 shadow-lg scale-105'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }
              `}
            >
              {activeCategory === category && (
                <span className="absolute inset-0 bg-white/70 rounded-full -z-10 animate-fadeIn"></span>
              )}
              {category}
            </button>
          ))}
        </div>
      </nav>

      {/* Product display grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))
        ) : (
          <div className="col-span-full flex items-center justify-center h-48 sm:h-64">
            <p className="text-gray-500 text-base sm:text-lg">No products found in this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};